// frontend/src/context/AuthContext.jsx

import React, { createContext, useState, useEffect, useContext } from 'react';
import { googleLogout } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode"; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // --- 1. Check for existing session on load ---
    useEffect(() => {
        const storedUser = localStorage.getItem('poly_user');
        const storedTime = localStorage.getItem('poly_login_time');
        
        if (storedUser && storedTime) {
            const now = Date.now();
            const daysPassed = (now - parseInt(storedTime)) / (1000 * 60 * 60 * 24);
            
            // 30-Day Expiry Check
            if (daysPassed < 30) {
                setUser(JSON.parse(storedUser));
            } else {
                logout(); // Session expired
            }
        }
        setLoading(false);
    }, []);

    // --- 2. Handle Login Success ---
    const handleLoginSuccess = (credentialResponse) => {
        try {
            // Decode the JWT token from Google
            const decoded = jwtDecode(credentialResponse.credential);
            
            // ?? SECURITY CHECK: Enforce Domain
            // 'hd' stands for Hosted Domain
            if (decoded.hd !== 'polyunity.com') {
                alert("Access Denied: You must use a @polyunity.com account.");
                return;
            }

            const userData = {
                name: decoded.name,
                email: decoded.email,
                picture: decoded.picture
            };

            // Save to Local Storage (Persistent)
            localStorage.setItem('poly_user', JSON.stringify(userData));
            localStorage.setItem('poly_login_time', Date.now().toString());
            
            setUser(userData);
        } catch (err) {
            console.error("Login Failed", err);
        }
    };

    const logout = () => {
        googleLogout();
        localStorage.removeItem('poly_user');
        localStorage.removeItem('poly_login_time');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, handleLoginSuccess, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);